'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.getMethodNames = void 0;
var parseWasm_1 = require('./parseWasm');
function getMethodNames(code_base64) {
  try {
    var ast = (0, parseWasm_1.parseWasm)(code_base64);
    return ast.body[0].fields
      .filter(function (x) {
        return x.type === 'ModuleExport' && x.descr.exportType === 'Func';
      })
      .map(function (x) {
        return x.name;
      });
  } catch (e) {
    console.error('Could not parse WASM', e);
    return [];
  }
}
exports.getMethodNames = getMethodNames;
//# sourceMappingURL=methods.js.map
